<template>
  <span
    class='text-xs font-medium text-center inline-flex items-center text-pink-600'
  >
    Credit
  </span>
</template>

<script lang="ts" setup>
</script>
